import React from "react";
import styled from "styled-components/native";
import { material } from "react-native-typography";
import { layoutCss } from "../layout/common";

// Text styling component for rows in lists
const RowText = styled.Text`
  ${material.body1Object}

  color: ${props => props.color || props.theme.fontColor};

  ${layoutCss}
`;

export default RowText;
